'use client';

import AzureAppInsights from '@/components/AppInsights/AppInsights';
import { ToastProvider } from '@/features/FeatureToast/client/context/ToastContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SessionProvider } from 'next-auth/react';
import { LanguageProvider } from '@/utils/contexts/LanguageContext';
import { useState } from 'react';
import OperationStatusProvider from '@/utils/contexts/OperationResultContext';

export default function Providers({ children }: { children: React.ReactNode }) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						refetchOnWindowFocus: false,
						staleTime: 1000 * 60 * 5,
					},
				},
			}),
	);

	return (
		<AzureAppInsights>
			<SessionProvider>
				<QueryClientProvider client={queryClient}>
					<LanguageProvider>
						<ToastProvider>
							<OperationStatusProvider>{children}</OperationStatusProvider>
						</ToastProvider>
					</LanguageProvider>
					<ReactQueryDevtools initialIsOpen={false} />
				</QueryClientProvider>
			</SessionProvider>
		</AzureAppInsights>
	);
}
